import isString from "lodash/isString"
import isEmpty from "lodash/isEmpty"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

/* Add Local Business JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addLocalBusinessJSONLD = () => {
  if (
    window.location.href.includes(`/us/en/locations/`) &&
    document.getElementById(`localJSONLD`) === null
  ) {
    const urlparts = window.location.href.split(`/`)
    const city = getCity(urlparts)
    const state = getState(urlparts)
    const localSiteName = getLocalsiteName(urlparts)
    const script = localBusinessJSONLD(localSiteName, city, state)
    addJSONLDToHead(script, `localJSONLD`)
  } else {
    removeElement(`localJSONLD`)
  }
}

// JSON LD template for localBusiness
export const localBusinessJSONLD = (localSiteName, city, state) => {
  const localBusinessTemplate = {
    "@context": `http://schema.org`,
    "@type": `LocalBusiness`,
    address: {
      "@type": `PostalAddress`,
      // "addressLocality": `\${city}`,
      // "addressRegion": `\${state}`,
      addressCountry: `USA`,
    },
    branchOf: {
      "@type": `Organization`,
      name: `Waste Management`,
    },
    logo: {
      "@type": `ImageObject`,
      contentUrl: `https://assets.wm.com/emails/us/images/WM-Logo.png`,
    },
    image: `https://assets.wm.com/emails/us/images/WM-Logo.png`,
    // "name": `\${localSiteName}`,
    // "url": `\${page}`,
  }
  localBusinessTemplate.address.addressLocality = city
  localBusinessTemplate.address.addressRegion = state
  localBusinessTemplate.url = window.location.href
  localBusinessTemplate.name = localSiteName
  return localBusinessTemplate
}

export const getCity = (permaLink) =>
  isEmpty(permaLink) || isEmpty(permaLink[7]) || !isString(permaLink[7])
    ? ``
    : permaLink[7]
        .split(` `)
        .map((i) => i[0].toUpperCase() + i.substring(1).toLowerCase())
        .join(` `)

export const getState = (permaLink) =>
  isEmpty(permaLink) || isEmpty(permaLink[6]) || !isString(permaLink[6])
    ? ``
    : permaLink[6]
        .split(` `)
        .map((i) => i[0].toUpperCase() + i.substring(1).toLowerCase())
        .join(` `)

export const getLocalsiteName = (permaLink) =>
  isEmpty(permaLink) || isEmpty(permaLink[8]) || !isString(permaLink[8])
    ? ``
    : permaLink[8]
        .split(`-`)
        .map((i) => i[0].toUpperCase() + i.substring(1).toLowerCase())
        .join(` `)
